import { useTranslation } from '@mint-lib/i18n';
import { WarningAltFilled } from '@mint-lib/icons';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';

type Props = {
  onClose: () => void;
  onSubmit: () => void;
};

export const MissingConfigDialog = ({ onClose, onSubmit }: Props) => {
  const { t } = useTranslation('@myn/import-hub');

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={handleOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="s">
          <DialogHeader>
            <DialogTitle className="flex flex-row items-center justify-center gap-2">
              <WarningAltFilled className="size-5 fill-warning-main" />
              <p>{t('Continue with incomplete mapping?')}</p>
            </DialogTitle>
          </DialogHeader>
          <DialogContent>
            <DialogDescription className="whitespace-pre-line">
              {t(
                `Your data file mapping is not fully completed.
                By proceeding, any unmapped rows will be ignored.`,
              )}
            </DialogDescription>
          </DialogContent>
          <DialogFooter>
            <Button variant="text" size="large" onClick={onClose}>
              {t('Back to edit')}
            </Button>
            <Button size="large" color="warning" onClick={onSubmit}>
              {t('Yes, proceed')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};
